import { z } from 'zod';
import { isIsoTimestamp } from '../../time';
import { timestampSchema } from '../common';

/**
 * When a stored secret stops working (wayai-pro/wayai#5417): an instant in the canonical form
 * (AGENTS.md › Timestamps), or null for a secret that does not expire, which is the default. It
 * belongs to the secret it was set beside — an org credential's, or a connection's own — so a new
 * secret written without one clears it, and a copy carries it only with the secret. A connection
 * linked to an org credential has none of its own.
 */
export const credentialExpiresAtSchema = timestampSchema
  .refine(isIsoTimestamp, 'Expected a canonical ISO timestamp')
  .nullable();

/**
 * Who set an expiry: the person who stored the secret (`user`), or the provider that reported it
 * (`provider`). Set by the server, never by a request body; null while there is no expiry.
 */
export type CredentialExpirySource = 'user' | 'provider';

/** A connection linked to an org credential has no expiry of its own: the credential holds it. */
export const LINKED_EXPIRY_REFUSAL = "A linked organization credential's expiry is set on the credential";

export interface CredentialExpiryResponse {
  expires_at: string | null;
  expires_at_source: CredentialExpirySource | null;
}
